import { forwardRef } from 'react';

import { TextFieldModel } from '../../../types';
import BaseStyleTextField from '../BaseStyleTextField';

import s from './AmountTextField.module.scss';

export interface AmountTextFieldProps extends TextFieldModel {
  right?: string;
}

const AmountTextField = forwardRef<HTMLInputElement, AmountTextFieldProps>(({ right, ...props }, ref) => {
  return (
    <BaseStyleTextField className={s.label} {...props} ref={ref}>
      {right && <span className={s.amount}>{right}</span>}
    </BaseStyleTextField>
  );
});

export default AmountTextField;
